// extracted by mini-css-extract-plugin
var _1 = "pJDNP";
var _2 = "jTFEi";
export { _1 as "tableName", _2 as "target" }
